import { AxiosResponse } from 'axios'
import { IAccountSeller, TMenuItem, TPermission } from 'containers/App/appLayoutTypes'

/* eslint-disable @typescript-eslint/naming-convention */
export enum SessionReliabilityInferOptions {
  TRUSTED = 'TRUSTED',
  UNTRUSTED = 'UNTRUSTED',
  UNDETERMINED = 'UNDETERMINED', // Representa uma análise inconclusiva
}
export type TGetSessionReliabilityInferResult = {
  result:
    | SessionReliabilityInferOptions.TRUSTED
    | SessionReliabilityInferOptions.UNTRUSTED
    | SessionReliabilityInferOptions.UNDETERMINED
  message: string
}

export interface IAccountService {
  getSeller: () => Promise<AxiosResponse<IAccountSeller>>
  getSellerPermissions: () => Promise<AxiosResponse<TPermission>>
  getServices: () => Promise<AxiosResponse<TMenuItem>>
  getIntegratorApplications: (platformName: string) => Promise<AxiosResponse>
  getExternalIdpaToken: () => Promise<AxiosResponse>
  getSessionReliabilityInfer: () => Promise<TGetSessionReliabilityInferResult>
}
